<template>
<div>

  <product-img v-if="img" @close="closeImg()" v-bind:img='img'></product-img>

<!--
<div class="card ">
 <div class="card-header text-white bg-info">
 
      
    <h4>
        <i  class="fas fa-camera mr-2" aria-hidden="true"></i>  
        GALLERY</h4> 
    
  </div>    
<div class="card-body">
-->

<div v-for="(_,index1) in items" :key="index1">
 
    <img @click="getProductImg(image)" class="img rounded" v-for="(image,index2) in images[index1]" :src="image.img" alt="" :key="index2"  />
    
</div>
</div>

<!--
</div>
</div>
-->
</template>
<script>
import api             from "@/api";
import { mapGetters }      from 'vuex';
import productImg          from '@/components/common/ProductImg.vue'
export default {
 props  : ['item'],
 components : {productImg}, 
 data () 
 {
    
    return {
        
        img         : '',
        items       : [],
        images      : [],
        spinner     : false,
        
       
    }
    
    },
 
  computed : {
     ...mapGetters(['company']) , 

     },

   created () 
    {
 
        this.getData()

     
    },
  methods: {
    getProductImg(item)
    {
     
      
      if(this.company.img_url)
      {
        this.img = item.img
        
      }
    },
    closeImg()
    {
      this.img = ''
    },
     async getData()
     { 

        this.images = [] 
        
        

        let sp   = {'sp'  : 'spProductColorImgList'}
        let data = {'productId' : this.item.productId}
        let  json      = Object.assign(data, sp);
        await api.post(json).then(res => {
                  

          if(res.status==200)
            {
              this.items  = res.data.recordsets[0]     
              let i = 1
              let max_img = this.company.img_num + 1
              this.items.forEach(item=>
              { 
                  let arr = []
                  for (i = 1; i < max_img ; i++) 
                  {
                    arr.push({'img': this.company.img_url + item.img + '_' + i + '.jpg'})    
                  }
                  this.images.push(arr)
              }

              )
              
            }
           else if(res.status==500)
           {
                alert(res.data)              
           } 
           else
            {
                alert('Network Error.')                            
            } 
          

          }).catch(err => {
              
              alert(err.message)    
              
          }).finally(() => {
            //this.spinner = false
        });
      
     }   

     


},
    


    
  
}
</script>

<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;  
}


.modal-header {
  background-color: yellow;
  color           : black;
}

 .modal { 
  text-align: center; 
        } 

 .img {
  border         : 3px solid #ddd;
  border-color   :darkgreen;
  border-radius  : 4px;
  padding        : 0px;
  width          : 200px;
  height         : 200px;
  margin-left    : 20px;
  margin-top     : 20px;
  cursor         : pointer; 
}

.imgTable {
 
  
  
  width          : 100px;
  
  
}

img:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}       
</style>
